'use client';
class Atom {
    get() {
        return this.state;
    }
    set(next) {
        if (this.state !== next) {
            this.state = next;
            this.notifyListeners();
        }
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    notifyListeners() {
        this.listeners.forEach((listener)=>listener(this.state));
    }
    constructor(initial){
        this.listeners = new Set();
        this.state = initial;
    }
}

export { Atom };
//# sourceMappingURL=Atom.js.map
